export const useSidebarStore = () => {
    const init = () => {
        window.Alpine.store("sidebar", {
            offcanvasOpen: false,
            offcanvasType: null,
            quickDepositAmount: 0,

            openOffcanvas(type) {
                this.offcanvasType = type;
                this.offcanvasOpen = true;
            },

            closeOffcanvas() {
                this.offcanvasOpen = false;
            },
        });
    };

    return { init };
};
